import React from "react"
import {CurrencyConfiguration} from "@next/utils"
import FacetsPrice from "../../../facetsPrice"
import FacetListLabelWrapper from "../../../horizontalFilters/facetListBox/facetListLabelWrapper"
import FacetListSelectLabel from "../../../horizontalFilters/facetListBox/facetListSelectLabel"
import {SELECT_RANGE} from "../../../../config/constants"

export interface Cashmere25FacetsPriceSelectorProps {
    name: string
    isTabbedFilter?: boolean
    globalPriceFormattingConfig: CurrencyConfiguration
}

export const Cashmere25FacetsPriceSelector = ({
    name,
    isTabbedFilter,
    globalPriceFormattingConfig,
}: Cashmere25FacetsPriceSelectorProps) => {
    return (
        <div>
            {/* this is to hide `SELECT_RANGE` text on mobile  */}
            {!isTabbedFilter && (
                <FacetListLabelWrapper>
                    <FacetListSelectLabel>
                        <span>{SELECT_RANGE}</span>
                    </FacetListSelectLabel>
                </FacetListLabelWrapper>
            )}
            <FacetsPrice
                name={name}
                isTabbedFilter={isTabbedFilter}
                globalPriceFormattingConfig={globalPriceFormattingConfig}
            />
        </div>
    )
}

export default Cashmere25FacetsPriceSelector
